export const env = (key?: string, defaultValue?: string) => {
  if (key === 'undefined') {
    return defaultValue || '';
  }
  return key || defaultValue || '';
};
